// Module
var code = "<p>This is the BRCA Exchange Summary View. Clinical significance for variants, where denoted, is from expert review by the ENIGMA consortium. Additional variant review is ongoing.</p> ";
// Exports
module.exports = code;